import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as fsFunctions from '../../../../fs-functions'
import * as fsEntry from '../fs-entry'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: fsEntry.RESOURCE.payload.dimension.partialId,
      partialId: fsEntry.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'Financial Statement function that this Financial Statement record is associated with',
    isOptional: true,
    name: 'Financial Statement Function',
    partialId: PartialId.Standard.create('func_fs'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        fsFunctions.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
